import { LocaleTypes } from '@dictionaries-types';

const preType = 'HOME_';

export const HomeActionTypes = {
  GET_SEARCH_RESULTS: `${preType}GET_SEARCH_RESULTS`,
  SET_SEARCH_RESULTS: `${preType}SET_SEARCH_RESULTS`,
  SET_SEARCH_LOADING: `${preType}SET_SEARCH_LOADING`,
  SET_SEARCH_VALUE: `${preType}SET_SEARCH_VALUE`,
  SET_NAVIGATION: `${preType}SET_NAVIGATION`,
  SET_NAVIGATION_LOADING: `${preType}SET_NAVIGATION_LOADING`,
  GET_CALENDAR_HOLIDAY_LIST: `${preType}GET_CALENDAR_HOLIDAY_LIST`,
  SET_CALENDAR_HOLIDAY_LIST: `${preType}SET_CALENDAR_HOLIDAY_LIST`,
  SET_CURRENT_ROUTE_AFFIX: `${preType}SET_CURRENT_ROUTE_AFFIX`,
};

const getSearchResults = (data: { searchValue: string }) => ({ type: HomeActionTypes.GET_SEARCH_RESULTS, data });
const setSearchLoading = (data: { searchLoading: boolean }) => ({ type: HomeActionTypes.SET_SEARCH_LOADING, data });
const setSearchResults = (data: any) => ({ type: HomeActionTypes.SET_SEARCH_RESULTS, data: data });
const setNavigation = (data: {navigation: any}) => ({ type: HomeActionTypes.SET_NAVIGATION, data: data });
const setSearchValue = (data: {value: string}) => ({ type: HomeActionTypes.SET_SEARCH_VALUE, data: data });
const setNavigationLoading = (data: {loading: boolean}) => ({ type: HomeActionTypes.SET_NAVIGATION_LOADING, data });
const getCalendarHolidayList = () => ({ type: HomeActionTypes.GET_CALENDAR_HOLIDAY_LIST });
const setRouteAffix = (data: {isMobileRoute: boolean, locale : LocaleTypes}) => ({ type: HomeActionTypes.SET_CURRENT_ROUTE_AFFIX, data: data });

export const HomeActions = {
  getSearchResults: getSearchResults,
  setSearchResults: setSearchResults,
  setSearchLoading: setSearchLoading,
  setNavigation: setNavigation,
  setSearchValue: setSearchValue,
  setNavigationLoading: setNavigationLoading,
  getCalendarHolidayList: getCalendarHolidayList,
  setRouteAffix: setRouteAffix,
};
